// Versão do admin injetada pelo Vite via `define` em build-time (lê de
// `package.json#version`). Usada em telemetria PostHog (`appVersion`).

declare const __APP_VERSION__: string;

/** Versão do build (`package.json#version`) ou `'dev'` fora do Vite (testes). */
export const APP_VERSION: string =
  typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev';
